import React from 'react';
import { Link } from 'react-router-dom';
import PosterGridElement from './PosterElement';
import { Poster } from '../types/types';
import './PostersGrid.css';

interface PostersGridProps {
    posters: Poster[];
}

const PostersGrid: React.FC<PostersGridProps> = ({ posters }) => {
    return (
        <section id="posters" className="posters-section">
            <h2>Posters</h2>
            <div className="posters-grid">
                {posters.map(poster => (
                    <Link
                        key={poster.id}
                        to={`/poster/${poster.id}`}
                        className="poster-link"
                    >
                        <PosterGridElement {...poster} />
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default PostersGrid; 